const base_url = process.env.REACT_APP_BASE_URL;
const file_url = process.env.REACT_APP_FILE_URL;
const stripeKey = process.env.REACT_APP_STRIPE_KEY;
export { base_url, file_url, stripeKey };